// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import { Queue, QueueFromJSON, QueueToJSON } from "./";

/**
 * Result of a traceability matrix export enqueue request. The export runs asynchronously on the background queue runner. Clients poll GET /queues/{id} until status is 2 or 3; on success, queue.results contains the generated CSV URL.
 * @export
 * @interface ExportTraceabilityMatrixResult
 */
export interface ExportTraceabilityMatrixResult {
  /**
   * Queue row ID for the asynchronous export job.
   * @type {number}
   * @memberof ExportTraceabilityMatrixResult
   */
  queueId?: number;
  /**
   * Stringified JSON array of header objects with key and label fields
   * @type {string}
   * @memberof ExportTraceabilityMatrixResult
   */
  headerRow?: string;
  /**
   * Array of stringified JSON row objects (one per requirement-test case link)
   * @type {Array<string>}
   * @memberof ExportTraceabilityMatrixResult
   */
  rows?: Array<string>;
  /**
   * Total number of data rows in the export
   * @type {number}
   * @memberof ExportTraceabilityMatrixResult
   */
  totalRows?: number;
  /**
   *
   * @type {Queue}
   * @memberof ExportTraceabilityMatrixResult
   */
  queue?: Queue;
}

export function ExportTraceabilityMatrixResultFromJSON(
  json: any
): ExportTraceabilityMatrixResult {
  return {
    queueId: !exists(json, "queueId") ? undefined : json["queueId"],
    headerRow: !exists(json, "header_row") ? undefined : json["header_row"],
    rows: !exists(json, "rows") ? undefined : json["rows"],
    totalRows: !exists(json, "total_rows") ? undefined : json["total_rows"],
    queue: !exists(json, "queue") ? undefined : QueueFromJSON(json["queue"]),
  };
}

export function ExportTraceabilityMatrixResultToJSON(
  value?: ExportTraceabilityMatrixResult
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    queueId: value.queueId,
    header_row: value.headerRow,
    rows: value.rows,
    total_rows: value.totalRows,
    queue: QueueToJSON(value.queue),
  };
}
